import { useContext } from 'react';

import { Button, ButtonSizes, ButtonVariant, Icon } from '@/shared/ui';

import { TattooSearchContext } from '../../context/TattooSearchContext';

type TattooSearchClearButtonProps = {
  onClear: () => void;
};

export const TattooSearchClearButton: React.FC<TattooSearchClearButtonProps> = ({ onClear }) => {
  const { handleClear } = useContext(TattooSearchContext);

  const handleClick = (): void => {
    onClear();
    handleClear();
  };

  return (
    <Button size={ButtonSizes.LG} variant={ButtonVariant.SECONDARY} onClick={handleClick}>
      <Icon name="clear_all" />
      Очистити
    </Button>
  );
};
